import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, mergeMap, takeUntil } from 'rxjs/operators';
import { HeaderService } from 'src/app/components/header/header.service';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { PriceyardService } from 'src/app/modules/priceyard/services/priceyard.service';

@Component({
  selector: 'app-calculate-price',
  templateUrl: './calculate-price.component.html',
  styleUrls: ['./calculate-price.component.scss']
})
export class CalculatePriceComponent implements OnInit,OnDestroy {
  actions: any[];
  showData: boolean = false;
  itemCost: number = 0;
  form: FormGroup;
  profitMargin: number;
  profitMarkup: number;
  profitAmount: number;
  account;
  private destroy$ = new Subject();
  loading: boolean = false;
  feeEstimate: any;
  currentCatalog: any;
  currentPriceOffer: any;
  isLoadingSetMinPrice: boolean;
  useLiveCal = new FormControl(true);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CalculatePriceComponent>,
    private planyardService: PlanyardService,
    private headerService:HeaderService,
    private snackBar: MatSnackBar,
    private priceyardService: PriceyardService,
    private gridActionService: GridActionsService
  ) {}
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.headerService.accountsSelected.subscribe((e) => {
      this.account = e[0];
    })
    this.data.selectedSku.priceBreakdown.filter((res)=>{
      if(res.name == 'Cost' || res.name == 'Prep Cost') this.itemCost += res.value;
    })
    this.form=new FormGroup({
      itemCost: new FormControl(this.itemCost,Validators.required),
      profitMarkUp: new FormControl(this.data.selectedSku.priceBreakdown[2].value,Validators.required),
      option:new FormControl('markup',Validators.required)
    })

    this.actions = this.data.actions || [
      { text: "Close"},
    ];

    this.calculateCatalogByAsin();
    this.calculatePriceOfferByAsin();

    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "FeesCalculation" && !this.gridActionService.isMinMaxUpdate))
    .subscribe((e) => {
      if(e.response.responseType.toLowerCase() == 'done'){
        this.calculatedResponse(e.response.data);
      } else if (e.response.responseType.toLowerCase() === "error") {
        this.loading = false;
        this.feeEstimate = null;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e.response.message,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      }
    })
  }

  close(e?) {
    this.dialogRef.close();
  }

  calculate(){
    this.loading = true;
    let estimateFeesRequests = {
      asin: this.data.selectedSku.asin,
      itemCost: +this.form.controls['itemCost'].value.toFixed(2),
      profitMarkupOptions: this.form.get('option').value,
      profitAmount: this.form.get('option').value == 'amount' ? +this.form.controls['profitMarkUp'].value.toFixed(2) : 0,
      profitMargin: this.form.get('option').value == 'margin' ? +this.form.controls['profitMarkUp'].value.toFixed(2) : 0,
      profitMarkup:  this.form.get('option').value == 'markup' ? +this.form.controls['profitMarkUp'].value.toFixed(2) : 0,
      isMinMaxUpdate: false,
      fulfillmentType: null
    };
    const payload = {
      estimateFeesRequests: this.useLiveCal.value ? [estimateFeesRequests] : estimateFeesRequests,
      account : this.account
    };
    if(this.useLiveCal.value){
      this.gridActionService.calculateAmazonPrice(payload);
    } else{
      this.calculatePrice(payload);
    }
  }

  calculatePrice(payload){
    this.planyardService.GetReferealFees(payload).subscribe((res:any) => {
      this.calculatedResponse(res);
    },(err)=>{
      this.loading = false;
      this.feeEstimate = null;
      this.showData = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
    });     
  }

  calculatedResponse(res){
     if(res.length> 0 && !res[0]?.isError) {
      this.feeEstimate = res[0];
      this.showData = true;
      this.loading = false;
      }else{
        this.loading = false;
        this.feeEstimate = null;
        this.showData = false;
        if(res[0]?.isError)
          this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: res[0]?.errorMessage,
              action: 'Dismiss',
              type: 'error',
            },
          }
        );        
      }
  }

calculateCatalogByAsin() {
  let payload: any ={
    asin: [this.data.selectedSku.asin],
    account: this.account
  }
  this.planyardService.GetCatlogByAsin(payload).pipe().subscribe((res : any) => {
    if(res){
      if(res) this.currentCatalog = res[0];
    }
  },(err)=>{
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: err.error?.error[0],
          action: 'Dismiss',
          type: 'error',
        },
      }
  );
  });
}

calculatePriceOfferByAsin() {
  let payload: any ={
    asin: this.data.selectedSku.asin,
    account: this.account
  }
  this.planyardService.GetPriceOfferByAsin(payload).pipe().subscribe((res: any) => {
    if(res){
      this.currentPriceOffer = res;
    }
  },(err)=>{
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: err.error?.error[0],
          action: 'Dismiss',
          type: 'error',
        },
      }
  );
  });
}

savePrice() {
  this.isLoadingSetMinPrice = true;
  const payload = {
    sku: this.data.selectedSku.sku,
    account: this.data.selectedSku.account,
    fulfillmentType: this.data.selectedSku.fulfillmentType,
    changingFactors: [{value: this.feeEstimate.minPrice.minPriceForFba, factor:"Min Price", setAuto:false}],
    modelName: this.data.selectedSku?.repricingModel?.name,
    pricingOn: this.data.selectedSku.pricingOn
  };
   let maxPrice = this.data.selectedSku.priceBreakdown.filter((res)=> res.name === 'Max Price')[0].value;
   if(maxPrice > this.feeEstimate.minPrice.minPriceForFba){
    this.priceyardService.changePriceFactor([payload]).subscribe(
      (response) => {
        if(response) this.isLoadingSetMinPrice = false;
        this.dialogRef.close('refresh');
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Min Price set successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      },
      (error) => {
        this.isLoadingSetMinPrice = false;
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Failed to save price changes, Please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
    );
   } else{
    this.isLoadingSetMinPrice = false;
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: 'Min Price is more than Max Price',
          action: 'Dismiss',
          type: 'info',
        },
      });
    }
  }

}